<template>
    <div>
      <changes-log :logs="taskLogs" :hideDetails="hideDetails"></changes-log>
    </div>
</template>
<script>
import axios from 'axios'
import ChangesLog from '../../../../../../Helpers/Tabs/ChangesLogs.vue'
import { eventBus } from '../../../../../../../main'

export default {
  props: {
    hideDetails: { type: Boolean, default: false }
  },
  data () {
    return {
      taskLogs: []
    }
  },
  components: {
    changesLog: ChangesLog
  },
  mounted () {
    this.getTaskHistory()

    eventBus.$on('loadHistory', () => {
      this.getTaskHistory()
    })
  },
  methods: {
    async getTaskHistory () {
      try {
        let r = await axios.get(`/v2/messages?type=action&targets[type]=tasks&targets[id]=${this.$route.params.id}`)
        this.taskLogs = r.data
      } catch (error) {
        this.$toastr.error('Failed to load project history', error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/TaskManager/Tasks/Single/Content/Tabs/LastActivity.vue